import { render, staticRenderFns } from "./MyUserProfile.vue?vue&type=template&id=2c261052&scoped=true"
import script from "./MyUserProfile.vue?vue&type=script&lang=js"
export * from "./MyUserProfile.vue?vue&type=script&lang=js"
import style0 from "./MyUserProfile.vue?vue&type=style&index=0&id=2c261052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c261052",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QItem,QItemSection,QCheckbox,QItemLabel,QIcon});
